import { mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { useFirstRunFooterStyles } from './FirstRunFooter.styles';
import { useFirstRunAriaLabel } from './hooks/useFirstRunAriaLabel';
export var FirstRunFooter = function (_a) {
    var activeSlideIdx = _a.activeSlideIdx, slideGroup = _a.slideGroup, active = _a.active, config = _a.config;
    var styles = useFirstRunFooterStyles();
    var ariaLabel = useFirstRunAriaLabel({
        ariaLabel: config.ariaLabels.paginationAriaLabel,
        idx: activeSlideIdx,
        slideGroupLength: slideGroup.length,
    });
    var containerStyle = React.useMemo(function () {
        return mergeClasses(styles.container, active && styles.containerActive);
    }, [styles.container, styles.containerActive, active]);
    var footerContent = React.useMemo(function () {
        return (React.createElement("div", { className: containerStyle },
            React.createElement("div", { className: styles.pagination, role: "tablist", "aria-label": ariaLabel }, slideGroup.map(function (_, idx) { return (React.createElement(PaginationIcon, { active: activeSlideIdx === idx, key: idx })); }))));
    }, [
        containerStyle,
        styles.pagination,
        ariaLabel,
        slideGroup,
        activeSlideIdx,
    ]);
    return footerContent;
};
var PaginationIcon = function (_a) {
    var active = _a.active;
    var styles = useFirstRunFooterStyles();
    var iconStyle = React.useMemo(function () {
        return mergeClasses(styles.paginationIcon, active && styles.paginationIconActive);
    }, [styles.paginationIcon, styles.paginationIconActive, active]);
    var paginationIcon = React.useMemo(function () {
        return (React.createElement("div", { className: iconStyle, role: "tab" }, "\u25CF"));
    }, [iconStyle]);
    return paginationIcon;
};
//# sourceMappingURL=FirstRunFooter.js.map